// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  mb, mt, mr, ml, pb
} from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledCoverMaxWidthPadding } from '@components/Wrappers';
import Grid from 'styled-components-grid';

import theme from '@theme';

const { colors } = theme;

export const MainHeadline = styled.h1`
  color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  margin: 2rem;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    margin: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
     font-size: 24px;
    line-height: 1.5;
    margin: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
  `}
  ${breakpoint('tablet', 'desktop')`
      ${({ why }) => why && 'margin-left: 100px'};
  `}
  ${breakpoint('desktop')`
          ${({ why }) => why && 'margin-left: 150px'};
  `}
`;

export const SecondHeadline = styled.h2`
  color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  margin: 2rem;
  font-weight: 800;
  line-height: 1.5;
  font-size: 42px;
  ${breakpoint('tablet', 'desktop')`
    font-size: 38px;
    margin: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
     font-size: 24px;
    line-height: 1.5;
    margin: 1rem;
    ${({ marketing }) => marketing && 'font-size: 17px'};
    ${({ nomargin }) => nomargin && 'margin-bottom: 0px'};
  `}
  ${breakpoint('tablet', 'desktop')`
      ${({ why }) => why && 'margin-left: 100px'};
  `}
  ${breakpoint('desktop')`
          ${({ why }) => why && 'margin-left: 150px'};
  `}
`;

export const BlogTypeHeadline = styled(SecondHeadline)`
  margin: 0;
  margin-bottom: 2rem;

  ${breakpoint('mobile', 'desktop')`
  margin-bottom: 1rem;
 `}
`;

export const MainSubHeadline = styled(MainHeadline)`
 ${breakpoint('mobile', 'tablet')`
 
 `}

${breakpoint('tablet', 'desktop')`
 
 `}

${breakpoint('desktop')`
 font-size: 32px
 `}
`;

export const StyledCoverMaxWidthNoBottomMargin = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: calc(100% - 60px);
  padding: 0 30px;
  margin-top: 0;

  ${breakpoint('mobile', 'desktop')`
    padding: 0 20px;
    width: calc(100% - 40px);
  `}
`;

export const StyledHeaderImage = styled.div`
  height: 600px;
  background: url('https://picsum.photos/id/199/1280/800');
  background-position: center;
  background-size: cover;
`;

export const StyledHeaderSearchBar = styled.div`
  height: 96px;
  background-image: linear-gradient(267deg, ${colors.lightCyan}, ${colors.lightBlue});
`;

export const StyledHeaderSearchBarContentWrapper = styled(StyledCoverMaxWidthPadding)`
  ${mb(0)}
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const StyledHeaderSearchBarHeadline = styled.div`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 500;
  color: ${colors.white};
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${colors.white};
`;

export const StyledContentContainer = styled(StyledCoverMaxWidthPadding)`
  ${mt(3.5)}
  ${breakpoint('desktop')`
    ${mt(5)}
    ${mb(6)}
  `}
`;

export const StyledArticleListContainer = styled.div`
  ${breakpoint('desktop')`
    ${mr(4)}
  `}
`;

export const StyledArticleCategoryListContainer = styled.div`
  ${pb(4)}
  ${breakpoint('desktop')`
    padding-bottom: 0;
    height: calc(100vh - 80px);
    position: sticky;
    top: 80px;
    overflow-y: auto;
    ${ml(4)}
  `}
`;

export const StyledcategoryListGridUnit = styled(Grid.Unit)`
  position: relative;
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;

export const StyledError = styled.p`
  color: ${theme.colors.darkBlue};
  font-size: 16px;
`;
